import Vue from 'vue'
import axios from 'axios'

const initState = {}

export default {
  namespaced: true,
  state: Vue.util.extend({}, initState),
  mutations: {},
  actions: {
    clearNotification({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/agency-courses-notification/clear`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    getAgencyCourses({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/agency-courses`)
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    getAgencyCourse({ commit }, { courseId }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/agency-courses/${courseId}`)
          .then((res) => resolve(res.data.course))
          .catch((error) => reject(error))
      })
    },
    getAdminCourses({ commit }, { queries }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/admin-courses`, { params: queries })
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    getAllAdminCourses({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/admin-courses/all`)
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    createAdminCourse({ commit }, course) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-courses`, course)
          .then((res) => resolve(res.data.course))
          .catch((error) => reject(error))
      })
    },
    getAdminCourse({ commit }, { courseId }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/admin-courses/${courseId}`)
          .then((res) => resolve(res.data.course))
          .catch((error) => reject(error))
      })
    },
    updateAdminCourse({ commit }, course) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/admin-courses/${course.id}`, course)
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    publishAdminCourse({ commit }, { courseId }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-courses/${courseId}/publish`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    cloneAdminCourse({ commit }, { courseId }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-courses/${courseId}/clone`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    deleteAdminCourse({ commit }, { courseId }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/admin-courses/${courseId}`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    convertCourse({ commit }, courseId) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-courses/${courseId}/convert`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    }
  },
  getters: {}
}